module.exports = __webpack_public_path__ + "static/img/1.f719d8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news6/1.jpg
// module id = yhWN
// module chunks = 1